import comp from "./ProgressIndicator";
export default comp;
